import { v4 as uuidv4Fallback } from 'uuid';

export const uuidv4 = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }
    // Fallback for environments where crypto.randomUUID is not available
    return uuidv4Fallback();
};
